export default __webpack_public_path__ + "static/media/cpr5.a306bc05.jpg";